import React from 'react'
import NimbleEmoji from 'emoji-mart/dist-es/components/emoji/nimble-emoji'
import { graphql, StaticQuery } from 'gatsby'

const Emoji = ({ data, ...rest }) => {
  const emojiSheet = JSON.parse(data.emojiData.internal.content)

  return <NimbleEmoji {...rest} data={emojiSheet} native={true} />
}

const StaticEmoji = (props) => (
  <StaticQuery
    query={graphql`
      query {
        emojiData {
          internal {
            content
          }
        }
      }
    `}
    render={(data) => <Emoji data={data} {...props} />}
  />
)

export { StaticEmoji as Emoji }
